// extracted by mini-css-extract-plugin
export default {"order":"Order_order__3cw+i","orderHeader":"Order_orderHeader__ChruE","icon":"Order_icon__wD1lB","return":"Order_return__0Dul7","returnText":"Order_returnText__d17Ur"};